/* Zugangsanfrage: Eingaben prüfen und Namen anzeigen.
 *
 * Reine Funktionen, kein DOM. Die Grenzen stehen auch in der Eintrage-Regel der
 * Datenbank (supabase/zugangsanfrage-erweitert.sql, access_requests_insert_public) —
 * beide gemeinsam ändern; ein Test gleicht sie ab. Die Datenbank ist die echte Sperre,
 * diese Prüfung spart nur den Umweg und liefert eine verständliche Meldung.
 */

export const REQUEST_LIMITS = {
  firstName: 100,
  lastName: 100,
  organization: 150,
  email: 254,
};

/* Bewusst grob: genau ein @, kein Leerraum, ein Punkt im Teil danach. Ob die Adresse
   wirklich existiert, zeigt sich erst bei der Einladung. Gleicher Ausdruck wie in der Datenbank. */
const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

/* Steuerzeichen (auch Zeilenumbrüche) → ein Leerzeichen; Mehrfach-Leerzeichen → eins. */
const clean = (v) => String(v ?? '').replace(/[\u0000-\u001f\u007f]+/g, ' ').replace(/\s{2,}/g, ' ').trim();

/**
 * Eingaben des Formulars bereinigen und prüfen.
 * @returns {{ok: true, value: {firstName, lastName, organization, email}} | {ok: false, field: string}}
 *   field = erstes ungültiges Feld (leer oder zu lang bzw. keine E-Mail-Adresse).
 */
export function normalizeAccessRequest(input) {
  const src = input || {};
  const value = {
    firstName: clean(src.firstName),
    lastName: clean(src.lastName),
    organization: clean(src.organization),
    email: clean(src.email).replace(/\s/g, '').toLowerCase(),
  };
  for (const field of ['firstName', 'lastName', 'organization', 'email']) {
    if (!value[field] || value[field].length > REQUEST_LIMITS[field]) return { ok: false, field };
  }
  if (!EMAIL.test(value.email)) return { ok: false, field: 'email' };
  return { ok: true, value };
}

/**
 * Anzeigename einer Anfrage. Altzeilen haben den ganzen Namen in `name` und
 * keinen `last_name`; neue Zeilen Vorname in `name`, Nachname in `last_name`.
 */
export function requestDisplayName(request) {
  return [request?.name, request?.last_name]
    .map((part) => String(part ?? '').trim())
    .filter(Boolean)
    .join(' ');
}
